import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { ONUManagementPage } from '@/features/devices'

export const Route = createFileRoute('/_authenticated/devices/onus')({
  component: () => (
    <RequirePermission permission='onus.read'>
      <ONUManagementPage />
    </RequirePermission>
  ),
})
